import React, { useState } from 'react'
import { Box, Flex, Link, Text } from '@chakra-ui/react'
import NextLink from 'next/link'

import { useCustomerInfo } from 'hooks/useCustomerInfo'
import { getInitials, getOrganizationInitials } from 'utils/getInitials'

import SelectUserOrganizationDropdown from '../SelectUserOrganizationDropdown'

const LoggedInAvatar = (): JSX.Element => {
  const { isLoading, customerInfo } = useCustomerInfo()

  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const useHasOrganization =
    !isLoading && customerInfo.customer?.organizations !== undefined && customerInfo.customer.organizations.length !== 0
  const isOrganizationCustomer = !isLoading && customerInfo.organization

  return (
    <Box width="40px" position="relative">
      <Box _hover={{ textDecor: 'none' }} className="">
        <NextLink href="/account" legacyBehavior>
          <Link _hover={{ textDecor: 'none' }} className="">
            <Flex
              justifyContent="center"
              alignItems="center"
              width="40px"
              height="40px"
              borderRadius="100%"
              border={isOrganizationCustomer ? '1.5px solid green' : undefined}
              backgroundColor={isOrganizationCustomer ? 'green.a175' : 'light'}
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              {isOrganizationCustomer ? (
                <Text color="white" fontSize="sm">
                  {getOrganizationInitials(customerInfo.organization?.name || '')}
                </Text>
              ) : (
                <Text color="green.a175" fontSize="sm">
                  {getInitials(customerInfo.customer?.fullName || '')}
                </Text>
              )}
            </Flex>
          </Link>
        </NextLink>

        {useHasOrganization && (
          <>
            <SelectUserOrganizationDropdown isOpen={isDropdownOpen} />
          </>
        )}
      </Box>
    </Box>
  )
}

export default LoggedInAvatar
